import { render, staticRenderFns } from "./posterDetail.vue?vue&type=template&id=f8af21e6&scoped=true&"
import script from "./posterDetail.vue?vue&type=script&lang=js&"
export * from "./posterDetail.vue?vue&type=script&lang=js&"
import style0 from "./posterDetail.vue?vue&type=style&index=0&id=f8af21e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8af21e6",
  null
  
)

export default component.exports